module.exports = __webpack_public_path__ + "img/ic-tazapay.084547bc.svg";